import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

import Header from './header';
import Footer from './footer';

import pic1 from './img/award.jpg';
import pic2 from './img/ejobindiaaward.jpg';
import pic3 from './img/nivt skill award.jpg';
import pic4 from './img/workingoffice.jpg';
import pic5 from './img/bisag-n.jpg';
import pic6 from './img/happytime.jpg';
import pic7 from './img/office.jpg';
import pic8 from './img/cultural.jpg';
import pic9 from './img/office sikandar.jpg';

const AboutUs = () => {
  const achievements = [
    'BCA Gold Medalist',
    'NIVT Skill Best Trainee Award – Major Project, Kolkata',
    'EjobIndia MERN Stack Project Gold Medalist – Kolkata',
  ];

  const schoolAchievements = [
    'Jago Foundation – 2nd Prize in Science Competition (2012)',
    'Jago Foundation – 1st Prize in Mathematics (2011)',
    'Jago Foundation by UNICEF – 1st Prize on Girls’ Culture Topic (2011)',
    'Gurukul Computer Academy, Hazaribagh – 1st Prize in C++ & SQL (2014) – Silver Medal',
    'Miracle English Classes, Hazaribagh – 1st Prize (2015) – Silver Medal',
  ];

  const features = [
    {
      number: '01',
      title: 'Expertly Designed Mock Tests',
      description:
        'Practice with carefully prepared tests based on the latest exam patterns and syllabus.',
    },
    {
      number: '02',
      title: 'Performance Analysis',
      description:
        'Understand your strengths and weaknesses through meaningful performance insights.',
    },
    {
      number: '03',
      title: 'Affordable & Accessible',
      description:
        'Quality exam preparation resources designed to remain accessible to students and job seekers.',
    },
    {
      number: '04',
      title: 'Comprehensive Study Materials',
      description:
        'Access current affairs, notes, practice resources and other useful preparation material.',
    },
    {
      number: '05',
      title: 'Simple User Experience',
      description:
        'A clean and easy-to-use platform designed to make online preparation convenient.',
    },
  ];

  const gallery = [
    pic1,
    pic2,
    pic3,
    pic4,
    pic5,
    pic6,
    pic7,
    pic8,
    pic9,
  ];

  return (
    <div className="about-page">

      <Header />

      {/* ================= HERO ================= */}
      <section className="about-hero">
        <Container>
          <Row className="align-items-center">

            <Col lg={8} className="mx-auto text-center">
              <span className="about-eyebrow">
                ABOUT ERWATODAY
              </span>

              <h1>
                Empowering Aspirants.
                <br />
                <span>Preparing for Success.</span>
              </h1>

              <p>
                ErwaToday is an online learning platform focused on helping
                students and job seekers prepare smarter for competitive
                examinations.
              </p>

              <div className="about-hero-line" />
            </Col>

          </Row>
        </Container>
      </section>


      {/* ================= WHO WE ARE ================= */}
      <section className="about-section">
        <Container>

          <Row className="align-items-center">

            <Col lg={5} className="mb-4 mb-lg-0">
              <div className="about-section-intro">

                <span className="about-label">
                  WHO WE ARE
                </span>

                <h2>
                  Building a smarter
                  <span> preparation experience.</span>
                </h2>

                <div className="about-accent-line" />

              </div>
            </Col>

            <Col lg={7}>

              <div className="about-text-block">

                <p>
                  Welcome to <strong>ErwaToday</strong>, your destination for
                  high-quality <strong>online mock test series</strong> for
                  government and competitive examinations.
                </p>

                <p>
                  Our mission is to <strong>empower students and job seekers</strong>
                  by providing reliable preparation resources for examinations
                  such as <strong>SSC, UPSC, IBPS</strong> and many more.
                </p>

                <p>
                  We believe that <strong>smart preparation leads to success</strong>.
                  Our mock tests are carefully curated according to the latest
                  exam patterns and syllabus, helping candidates practice in a
                  focused and structured manner.
                </p>

                <p>
                  Beyond practice tests, ErwaToday aims to provide useful
                  performance insights and preparation resources so that
                  aspirants can identify their strengths and improve their
                  weaker areas.
                </p>

              </div>

            </Col>

          </Row>

        </Container>
      </section>


      {/* ================= WHY CHOOSE US ================= */}
      <section className="why-erwatoday">

        <Container>

          <div className="section-heading text-center">

            <span className="about-label">
              WHY ERWATODAY
            </span>

            <h2>
              Everything you need to
              <span> prepare better.</span>
            </h2>

            <p>
              Designed around the needs of modern competitive-exam aspirants.
            </p>

          </div>


          <Row className="g-4 mt-4">

            {features.map((feature) => (

              <Col
                lg={4}
                md={6}
                key={feature.number}
              >

                <div className="feature-card">

                  <div className="feature-number">
                    {feature.number}
                  </div>

                  <div className="feature-content">

                    <h3>
                      {feature.title}
                    </h3>

                    <p>
                      {feature.description}
                    </p>

                  </div>

                </div>

              </Col>

            ))}

          </Row>

        </Container>

      </section>


      {/* ================= NAME STORY ================= */}
      <section className="name-story">

        <Container>

          <Row className="justify-content-center">

            <Col lg={9}>

              <div className="story-card">

                <span className="about-label">
                  OUR NAME
                </span>

                <h2>
                  Why the name
                  <span> “ErwaToday”?</span>
                </h2>

                <p>
                  The name <strong>“ErwaToday”</strong> holds a special place
                  in our hearts. It is dedicated to the founder’s respected
                  mother and represents values of <strong>love, inspiration,
                  guidance and dedication</strong>.
                </p>

                <p>
                  These values continue to inspire the vision behind the
                  platform and our commitment towards helping aspirants
                  move closer to their goals.
                </p>

              </div>

            </Col>

          </Row>

        </Container>

      </section>


      {/* ================= FOUNDER ================= */}
      <section className="founder-section">

        <Container>

          <div className="section-heading text-center">

            <span className="about-label">
              OUR FOUNDER
            </span>

            <h2>
              Meet the person
              <span> behind ErwaToday.</span>
            </h2>

          </div>


          <Row className="justify-content-center mt-5">

            <Col lg={10}>

              <Card className="founder-card border-0">

                <Card.Body>

                  <div className="founder-top">

                    <div className="founder-avatar">
                      SP
                    </div>

                    <div>

                      <span className="founder-role">
                        FOUNDER
                      </span>

                      <h3>
                        Er. Sikandar Pandit
                      </h3>

                      <p>
                        Technology professional & education platform founder
                      </p>

                    </div>

                  </div>


                  <div className="founder-divider" />


                  <Row>

                    <Col md={6}>

                      <div className="founder-info">

                        <span className="info-label">
                          EDUCATION
                        </span>

                        <h4>
                          BCA & MCA
                        </h4>

                        <p>
                          Gold Medalist
                        </p>

                      </div>


                      <div className="founder-info">

                        <span className="info-label">
                          PROFESSIONAL EXPERIENCE
                        </span>

                        <p>
                          IT Executive at BISAG-N
                          <br />
                          Bhaskaracharya National Institute for Space
                          Applications and Geo-informatics
                        </p>

                      </div>

                    </Col>


                    <Col md={6}>

                      <div className="founder-info">

                        <span className="info-label">
                          AWARDS & ACHIEVEMENTS
                        </span>

                        <ul>

                          {achievements.map((item, index) => (
                            <li key={index}>
                              {item}
                            </li>
                          ))}

                        </ul>

                      </div>

                    </Col>

                  </Row>

                </Card.Body>

              </Card>

            </Col>

          </Row>

        </Container>

      </section>


      {/* ================= SCHOOL ACHIEVEMENTS ================= */}
      <section className="school-achievements">

        <Container>

          <Row className="justify-content-center">

            <Col lg={9}>

              <div className="achievement-panel">

                <div className="section-heading">

                  <span className="about-label">
                    EARLY ACHIEVEMENTS
                  </span>

                  <h2>
                    School Life
                    <span> Achievements</span>
                  </h2>

                </div>


                <div className="achievement-list">

                  {schoolAchievements.map((item, index) => (

                    <div
                      className="achievement-item"
                      key={index}
                    >

                      <div className="achievement-index">
                        {String(index + 1).padStart(2, '0')}
                      </div>

                      <p>
                        {item}
                      </p>

                    </div>

                  ))}

                </div>

              </div>

            </Col>

          </Row>

        </Container>

      </section>


      {/* ================= GALLERY ================= */}
      <section className="gallery-section">

        <Container>

          <div className="section-heading text-center">

            <span className="about-label">
              OUR JOURNEY
            </span>

            <h2>
              Awards & <span>Achievements</span>
            </h2>

            <p>
              A glimpse of the journey, achievements and memorable moments.
            </p>

          </div>


          <Row className="g-4 mt-4">

            {gallery.map((image, index) => (

              <Col
                lg={4}
                md={6}
                key={index}
              >

                <div className="gallery-card">

                  <img
                    src={image}
                    alt={`ErwaToday achievement ${index + 1}`}
                  />

                  <div className="gallery-overlay">
                    <span>
                      {String(index + 1).padStart(2, '0')}
                    </span>
                  </div>

                </div>

              </Col>

            ))}

          </Row>

        </Container>

      </section>


      {/* ================= CTA ================= */}
      <section className="about-cta">

        <Container>

          <div className="cta-card text-center">

            <span className="about-label">
              START YOUR JOURNEY
            </span>

            <h2>
              Prepare smarter.
              <br />
              <span>Perform better.</span>
            </h2>

            <p>
              Explore ErwaToday and take the next step towards your
              competitive-exam goals.
            </p>

          </div>

        </Container>

      </section>


      <Footer />


      {/* ================= PAGE STYLES ================= */}
      <style>{`

        .about-page {
          background: #f7f9fc;
          color: #172033;
          overflow-x: hidden;
        }

        .about-hero {
          padding: 110px 20px 100px;
          background:
            linear-gradient(135deg, #081a33 0%, #0c315c 55%, #1263a0 100%);
          color: #fff;
          position: relative;
        }

        .about-hero:after {
          content: "";
          position: absolute;
          width: 260px;
          height: 260px;
          border-radius: 50%;
          border: 1px solid rgba(255,255,255,.12);
          right: 8%;
          top: 20%;
        }

        .about-eyebrow,
        .about-label {
          display: inline-block;
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 2px;
          color: #1689ff;
          margin-bottom: 16px;
        }

        .about-hero .about-eyebrow {
          color: #8fc9ff;
        }

        .about-hero h1 {
          font-size: clamp(42px, 6vw, 72px);
          line-height: 1.05;
          font-weight: 800;
          margin-bottom: 25px;
          letter-spacing: -2px;
        }

        .about-hero h1 span,
        .about-section-intro h2 span,
        .section-heading h2 span,
        .name-story h2 span,
        .story-card h2 span,
        .about-cta h2 span {
          color: #1689ff;
        }

        .about-hero p {
          max-width: 720px;
          margin: 0 auto;
          color: rgba(255,255,255,.78);
          font-size: 18px;
          line-height: 1.8;
        }

        .about-hero-line {
          width: 70px;
          height: 4px;
          background: #1689ff;
          margin: 35px auto 0;
          border-radius: 20px;
        }

        .about-section {
          padding: 100px 20px;
          background: #fff;
        }

        .about-section-intro h2,
        .section-heading h2,
        .story-card h2 {
          font-size: 40px;
          line-height: 1.15;
          font-weight: 800;
          letter-spacing: -1px;
          margin: 0;
        }

        .about-accent-line {
          width: 55px;
          height: 4px;
          background: #1689ff;
          margin-top: 25px;
          border-radius: 10px;
        }

        .about-text-block {
          font-size: 17px;
          line-height: 1.9;
          color: #596579;
        }

        .about-text-block p {
          margin-bottom: 20px;
        }

        .about-text-block strong {
          color: #172033;
        }

        .why-erwatoday {
          padding: 100px 20px;
          background: #f1f5fa;
        }

        .section-heading p {
          color: #718096;
          margin-top: 15px;
          font-size: 16px;
        }

        .feature-card {
          height: 100%;
          padding: 32px;
          background: #fff;
          border: 1px solid #e5ebf2;
          border-radius: 18px;
          transition: all .25s ease;
          display: flex;
          gap: 20px;
        }

        .feature-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 18px 45px rgba(24,45,75,.10);
          border-color: #c8ddf3;
        }

        .feature-number {
          min-width: 48px;
          height: 48px;
          border-radius: 12px;
          background: #e9f4ff;
          color: #1689ff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 13px;
        }

        .feature-content h3 {
          font-size: 18px;
          font-weight: 750;
          margin-bottom: 10px;
        }

        .feature-content p {
          margin: 0;
          color: #718096;
          line-height: 1.7;
          font-size: 14px;
        }

        .name-story {
          padding: 100px 20px;
          background: #fff;
        }

        .story-card {
          padding: 55px;
          border-radius: 24px;
          background: #f4f8fc;
          border-left: 5px solid #1689ff;
        }

        .story-card p {
          color: #64748b;
          line-height: 1.9;
          font-size: 16px;
          margin-top: 25px;
        }

        .founder-section {
          padding: 100px 20px;
          background: #f7f9fc;
        }

        .founder-card {
          padding: 45px;
          border-radius: 24px;
          box-shadow: 0 20px 60px rgba(20,42,70,.08);
          background: #fff;
        }

        .founder-top {
          display: flex;
          align-items: center;
          gap: 22px;
        }

        .founder-avatar {
          width: 78px;
          height: 78px;
          border-radius: 22px;
          background: #0b315c;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: 800;
        }

        .founder-role,
        .info-label {
          color: #1689ff;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 1.5px;
        }

        .founder-top h3 {
          font-size: 28px;
          margin: 5px 0;
          font-weight: 800;
        }

        .founder-top p {
          margin: 0;
          color: #718096;
        }

        .founder-divider {
          height: 1px;
          background: #e6ebf0;
          margin: 35px 0;
        }

        .founder-info {
          margin-bottom: 30px;
        }

        .founder-info h4 {
          margin: 8px 0 2px;
          font-size: 21px;
        }

        .founder-info p,
        .founder-info li {
          color: #687589;
          line-height: 1.8;
        }

        .founder-info ul {
          padding-left: 18px;
          margin-top: 10px;
        }

        .school-achievements {
          padding: 100px 20px;
          background: #fff;
        }

        .achievement-panel {
          padding: 50px;
          border-radius: 24px;
          background: #0b315c;
          color: #fff;
        }

        .achievement-panel .about-label {
          color: #8fc9ff;
        }

        .achievement-panel h2 {
          color: #fff;
        }

        .achievement-panel h2 span {
          color: #5db0ff;
        }

        .achievement-list {
          margin-top: 40px;
        }

        .achievement-item {
          display: flex;
          align-items: center;
          gap: 20px;
          padding: 20px 0;
          border-bottom: 1px solid rgba(255,255,255,.12);
        }

        .achievement-item:last-child {
          border-bottom: none;
        }

        .achievement-index {
          font-size: 12px;
          font-weight: 800;
          color: #69b7ff;
          min-width: 30px;
        }

        .achievement-item p {
          margin: 0;
          color: rgba(255,255,255,.82);
          line-height: 1.6;
        }

        .gallery-section {
          padding: 100px 20px;
          background: #f7f9fc;
        }

        .gallery-card {
          height: 360px;
          overflow: hidden;
          border-radius: 20px;
          position: relative;
          background: #ddd;
          box-shadow: 0 10px 35px rgba(20,42,70,.08);
        }

        .gallery-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform .5s ease;
        }

        .gallery-card:hover img {
          transform: scale(1.06);
        }

        .gallery-overlay {
          position: absolute;
          inset: auto 0 0 0;
          padding: 25px;
          background: linear-gradient(
            transparent,
            rgba(0,0,0,.65)
          );
          color: #fff;
          font-weight: 800;
        }

        .about-cta {
          padding: 80px 20px 100px;
          background: #f7f9fc;
        }

        .cta-card {
          padding: 70px 25px;
          border-radius: 28px;
          background: linear-gradient(135deg, #071a32, #0d4d83);
          color: #fff;
          box-shadow: 0 20px 60px rgba(8,35,65,.15);
        }

        .cta-card .about-label {
          color: #8fc9ff;
        }

        .cta-card h2 {
          font-size: 44px;
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 20px;
        }

        .cta-card p {
          color: rgba(255,255,255,.75);
          max-width: 600px;
          margin: auto;
          line-height: 1.8;
        }

        @media (max-width: 767px) {

          .about-hero {
            padding: 75px 20px;
          }

          .about-hero h1 {
            font-size: 42px;
          }

          .about-section,
          .why-erwatoday,
          .name-story,
          .founder-section,
          .school-achievements,
          .gallery-section {
            padding: 70px 15px;
          }

          .about-section-intro h2,
          .section-heading h2,
          .story-card h2 {
            font-size: 32px;
          }

          .story-card,
          .founder-card,
          .achievement-panel {
            padding: 30px 22px;
          }

          .founder-top {
            align-items: flex-start;
          }

          .founder-avatar {
            width: 60px;
            height: 60px;
            border-radius: 16px;
          }

          .founder-top h3 {
            font-size: 22px;
          }

          .gallery-card {
            height: 300px;
          }

          .cta-card {
            padding: 55px 20px;
          }

          .cta-card h2 {
            font-size: 36px;
          }
        }

      `}</style>

    </div>
  );
};

export default AboutUs;